import React, { forwardRef } from "react";
import { Spin } from "antd";
import { ReactComponent as SmallShopifyLoader } from "../../../assets/images/SmallShopifyLoader.svg";

import { useShopifyApp } from "../../../hooks/useShopifyApp";

import { Container } from "./styles";

const Loader = forwardRef(({ className }, ref) => {
  const isShopifyApp = useShopifyApp();

  return (
    <Container ref={ref} className={className}>
      {isShopifyApp ? <SmallShopifyLoader /> : <Spin />}
    </Container>
  );
});

export default Loader;
